// The compiler contract: the types + error class that every Munos host and the
// WASM compiler adapter share. This is pipeline-free and isomorphic — it pulls
// in no lexer/parser/checker/codegen, so it is safe to import from the browser
// bundle and from the WASM adapter.
//
// The Munos compiler is the Rust/WASM module (packages/munos-rs); this file is
// the boundary it and its hosts agree on. See docs/rust-compiler-migration.md.
// Thrown on any lex/parse/type/codegen error. The message is preamble-adjusted
// and carries a code frame. Hosts catch it to surface a compile failure.
export class CompileError extends Error {
}
//# sourceMappingURL=compiler-contract.js.map